<af-main-container
    [title]="(organizationId ? 'i18n_lib_breadcrumb#OrganizationEdit' : 'i18n_lib_breadcrumb#OrganizationCreate') | translate"
    [spinnerIds]="organizationId && ['initial']"
    [tabPathToTab]="tabPathToTab"
    [customLastBreadcrumb]="organization?.nameRu"
    [specialFilter]="filterOrganizationIdPath">
    <div fxLayout="column" class="w-100 radius-16 bc-mono-white p-24 mt-24">
        <form [formGroup]="form"
              (submit)="submit()"
              fxLayout="column"
              fxLayoutAlign="start start">
            <div class="grid-form-container">
                <div fxLayout="column" fxLayoutAlign="start start">
                    <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelBin' | translate }}*</div>
                    <mat-form-field class="w-100 mt-4" [class.value-not-empty]="form.controls.bin.valid">
                        <input matInput
                               [placeholder]="'i18n_af_placeholderOrganizationBin' | translate"
                               formControlName="bin"
                               name="bin"
                               mask="000000000000"/>
                        @if (form.controls.bin.hasError('required')) {
                            <mat-error class="c-secondary-red-900">
                                {{ 'i18n_af_fieldValidationRequired' | translate }}
                            </mat-error>
                        }
                        @if (form.controls.bin.hasError('pattern')) {
                            <mat-error class="c-secondary-red-900">
                                {{ 'i18n_af_fieldValidationBin' | translate }}
                            </mat-error>
                        }
                    </mat-form-field>
                </div>

                <div fxLayout="column" fxLayoutAlign="start start">
                    <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelOrganizationNameRu' | translate }}*</div>
                    <mat-form-field class="w-100 mt-4" [class.value-not-empty]="form.controls.nameRu.valid">
                        <input matInput
                               [placeholder]="'i18n_af_placeholderOrganizationName' | translate"
                               formControlName="nameRu"
                               name="nameRu"/>
                        @if (form.controls.nameRu.hasError('required')) {
                            <mat-error class="c-secondary-red-900">
                                {{ 'i18n_af_fieldValidationRequired' | translate }}
                            </mat-error>
                        }
                    </mat-form-field>
                </div>

                <div fxLayout="column" fxLayoutAlign="start start">
                    <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelOrganizationNameKz' | translate }}</div>
                    <mat-form-field class="w-100 mt-4" [class.value-not-empty]="form.value.nameKz">
                        <input matInput
                               [placeholder]="'i18n_af_placeholderOrganizationName' | translate"
                               formControlName="nameKz"
                               name="nameKz"/>
                    </mat-form-field>
                </div>

                <div fxLayout="column" fxLayoutAlign="start start">
                    <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelOrganizationNameEn' | translate }}</div>
                    <mat-form-field class="w-100 mt-4" [class.value-not-empty]="form.value.nameEn">
                        <input matInput
                               [placeholder]="'i18n_af_placeholderOrganizationName' | translate"
                               formControlName="nameEn"
                               name="nameEn"/>
                    </mat-form-field>
                </div>

                <div fxLayout="column" fxLayoutAlign="start start">
                    <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelOrganizationType' | translate }}*</div>
                    <mat-form-field class="w-100 mt-4" [class.value-not-empty]="form.value.type">
                        <mat-select formControlName="type"
                                    class="h-100"
                                    fxLayoutAlign="start center"
                                    panelClass="hide-scroll-bar"
                                    [placeholder]="'i18n_af_placeholderOrganizationType' | translate">
                            @for (organizationType of organizationTypes; track organizationType) {
                                <mat-option [value]="organizationType">
                                    {{ 'i18n_af_organizationType#' + organizationType | translate }}
                                </mat-option>
                            }
                        </mat-select>
                        <ui-kit-svg matSuffix class="i-16 mr-16 pointer c-primary-gray-600" name="ic_arrow_down"/>
                        @if (form.controls.type.hasError('required')) {
                            <mat-error class="c-secondary-red-900">
                                {{ 'i18n_af_fieldValidationRequired' | translate }}
                            </mat-error>
                        }
                    </mat-form-field>
                </div>

                <div fxLayout="column" fxLayoutAlign="start start">
                    <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelEmail' | translate }}*</div>
                    <mat-form-field class="w-100 mt-4" [class.value-not-empty]="form.controls.email.valid">
                        <input matInput
                               [placeholder]="'i18n_af_placeholderOrganizationEmail' | translate"
                               formControlName="email"
                               name="email"/>
                        @if (form.controls.email.hasError('required')) {
                            <mat-error class="c-secondary-red-900">
                                {{ 'i18n_af_fieldValidationRequired' | translate }}
                            </mat-error>
                        }
                        @if (form.controls.email.hasError('email')) {
                            <mat-error class="c-secondary-red-900">
                                {{ 'i18n_af_fieldValidationEmail' | translate }}
                            </mat-error>
                        }
                    </mat-form-field>
                </div>

                <af-phone-number
                    [control]="form.controls.phone"
                    [selectedPhoneInfoControl]="form.controls.selectedPhoneInfo"
                    [strictValidation]="true"
                    label="i18n_af_labelOrganizationPhone"/>
            </div>

            @if (!organizationId) {
                <af-files class="w-100 mt-24"
                          [form]="form"
                          [bucket]="BucketName.ORGANIZATION_FILES"
                          [filterDictionaryBy]="organizationScope"
                          [excludeFromDictionary]="[]"
                          [mimeTypes]="ORGANIZATION_MIME_TYPES"
                          label="i18n_af_labelAdditionalDocuments"
                          hintTranslationKey="i18n_af_hintOrganizationDocument"/>
            }

            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px" class="mt-24">
                <ui-kit-button spinnerId="submit"
                               [disabled]="form.invalid"
                               [label]="'i18n_af_buttonSave' | translate"/>
                <ui-kit-button color="accent"
                               buttonType="button"
                               type="text"
                               [label]="'i18n_af_buttonCancel' | translate"
                               (clickListener)="navigateBack()"/>
            </div>
        </form>
    </div>
</af-main-container>
